import axios from 'axios';

// Índice de un programa para la generación de lotes con IA: GET
// /v3/digital-programs/{guid}/activity-generation-index (api-v3). Devuelve 404 si el
// programa no existe o está borrado.
export const DIGITAL_PROGRAMS = 'v3/digital-programs';

export function getActivityGenerationIndex(programGuid, { signal } = {}) {
  // El interceptor de axios convierte una petición abortada en { cancelled: true }, la misma
  // forma que el resto de cancelaciones del proyecto, así que el signal encaja sin más manejo.
  return axios.get(`${DIGITAL_PROGRAMS}/${programGuid}/activity-generation-index`, { signal });
}
